<template lang="pug">
md-layout(md-column)
  md-layout(md-column, v-if='videos && videos.length > 0')
    .md-subheading {{ label }}
      div.titleLine.styleRow
        p.rowElements
        p.rowElements Name
        p.rowElements Advisor
        p.rowElements Category
        p.rowElements Duration
        p.rowElements Provider
        p.rowElements Updated
        p.rowElements(v-if='allowDelete')
      div.styleRow.rowVideos(v-for='(item, index) in videos', :key='item._id')
        div.rowElements
          md-avatar
              img(:src="getVideoPoster(item)", :alt='item.name')
        div.rowElements {{ item.name }}
        div.rowElements.overflow {{ advisor(item) }}
        div.rowElements.overflow {{ item.categories[0] }}
        div.rowElements {{ secondsToHms(item.duration) }}
        div.rowElements {{ item.credit }}
        div.rowElements {{ item.lastUpdated | moment('from') }}
        div.rowElements(v-if='allowDelete')
          md-spinner.md-accent(md-indeterminate, :md-size='25', v-if='deletingItem === index')
          md-button.md-icon-button.md-warn.btn(@click='removeItem(index)', v-else)
            md-icon.icon(md-iconset="fa fa-trash-alt")

  // No items message
  md-layout#no-results(md-align='center', v-else)
    span.md-subheading
      md-icon.md-accent.on-left(md-iconset="fa fa-exclamation-circle")
      | This playlist has no videos
</template>

<script>
  import videoMixin from '../../shared-components/videomixins';

  export default {
    mixins: [videoMixin],
    props: {
      allowDelete: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: 'Content'
      },
      videos: {
        type: Array,
        required: true
      },
      deletingItem: {
        type: Number
      }
    },
    methods: {
      advisor(item) {

        let checks = [];

        if(!item.tags.length) {
          checks.push('tags');
        }

        if(!item.categories.length) {
          checks.push('categories');
        }

        if(!item.description.length) {
          checks.push('description');
        }

        return checks.length ? `✘ Missing: ${checks.join(', ')}` : '';
      },
      removeItem(index) {
        this.$emit('removeItem', index);
      }
    }
  };
</script>

<style lang="scss" scoped>

@media (max-width: 1200px) {
  .btn{
  margin: 4px;
  box-shadow: none ;
  min-width: 35px;
  min-height: 35px;
  height: 35px;
  width: 35px;
  }
  .icon{
    display: flex !important;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
}

@media (max-width: 1000px) {
  .btn{
  margin: 2px;
  box-shadow: none ;
  min-width: 30px;
  min-height: 30px;
  height: 30px;
  width: 30px;
  }
.icon{
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  }
}
.md-icon.on-left {
    margin-top: -3px;
    margin-right: 5px;
  }

.styleRow{
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}
.styleRow p {
  font-weight: 600;
}
.rowElements {
  flex: 1;
  padding: 5px 2px;
  max-height: 80px;
  @media (max-width: 1000px) {
      font-size: 12px;
  }
}
.rowVideos {
  border: 1px solid transparent;
  &:hover{
    background-color: rgba(127, 199, 228, 0.112) !important;
    border-radius: 6px;
  }
}
.titleLine {
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(153, 155, 155, 0.486);
  margin-bottom: 10px;
}

.overflow{
  overflow: hidden;
  text-overflow: ellipsis;

}

.md-subheading{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/playlist/PlaylistContentTable.vue